import React, { useState, useEffect } from 'react';
import 'tailwindcss/tailwind.css';
import { Link } from 'react-router-dom';
import { getAllCars } from '../utils/Api';

const Home = () => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await getAllCars();
        const sortedCars = response.sort((a) => (a.verkocht ? 1 : -1))
        setCars(sortedCars);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchCars();
  }, []);

  const getDefaultImage = () => {
    return 'https://via.placeholder.com/400x300?text=Geen+Afbeelding';
  };

  const getCarImage = (car) => {
    if (car.imageLinks && car.imageLinks.length > 0) {
      const imageUrl = car.imageLinks[0].replace(/^\/+/, '');
      return `https://s-backend-rebuild-production.up.railway.app/${imageUrl}`;
    }
    return getDefaultImage();
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="relative h-[600px] bg-black -mt-[100px]">
        <div className="absolute inset-0 bg-gradient-to-r from-black to-transparent z-10"></div>
        <img
          src="https://images.unsplash.com/photo-1632686341231-0a65b83bafaa?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Luxe Auto"
          className="w-full h-full object-cover opacity-75"
        />
        <div className="absolute top-1/2 left-12 transform -translate-y-1/2 z-20 text-white">
          <h1 className="text-5xl font-bold mb-4">Ontdek Uw Droomauto</h1>
          <p className="text-xl mb-8">Verken onze exclusieve collectie premium voertuigen</p>
          <Link
            to="/Aanbod"
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md text-lg font-semibold transition duration-300"
          >
            Bekijk Alle Auto's
          </Link>
        </div>
      </div>


      <div className="max-w-7xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold mb-8">Uitgelichte Voertuigen</h2>

        {loading ? (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {cars.slice(0, 6).map((car) => (
              <Link
                to={`/product/${car.id}`}
                key={car.id}
                className="group focus:outline-none no-underline hover:no-underline"
              >
                <div className={`bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1 h-96 flex flex-col ${car.verkocht ? 'relative' : ''}`}>

                  <div className="relative h-48">
                    <img
                      src={getCarImage(car)}
                      alt={`${car.merk} ${car.model}`}
                      className={`w-full h-full object-cover ${car.verkocht ? 'opacity-70' : ''}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = getDefaultImage();
                      }}
                    />

                    {car.verkocht && (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="bg-red-600 text-white font-bold py-2 px-6 rounded-lg transform rotate-12 shadow-lg">
                          VERKOCHT
                        </div>
                      </div>
                    )}

                    <div className="absolute top-3 right-3 bg-blue-600 rounded-lg px-3 py-2">
                      <div className="text-white font-bold text-lg">
                        € {car.prijs?.toLocaleString()}
                      </div>
                    </div>
                  </div>

                  <div className="p-4">
                    <h3 className="text-xl font-semibold mb-2 text-blue-600">{car.merk} {car.model}</h3>
                    {car.uitvoering && (
                      <p className="text-gray-600 text-sm mb-2">{car.uitvoering}</p>
                    )}
                    {!car.verkocht ? (
                      <div className="grid grid-cols-2 gap-3 text-gray-600">
                        <div className="flex items-center">
                          <i className="fas fa-tachometer-alt mr-1"></i>
                          {car.kmstand?.toLocaleString()} km
                        </div>
                        <div className="flex items-center">
                          <i className="fas fa-gas-pump mr-1"></i>
                          {car.brandstof}
                        </div>
                        <div className="flex items-center">
                          <i className="fas fa-cog mr-1"></i>
                          {car.transmissie}
                        </div>
                        <div className="flex items-center">
                          <i className="fas fa-calendar mr-1"></i>
                          {new Date(car.datum).toLocaleDateString('en-GB')}
                        </div>
                      </div>
                    ) : (
                      <div className="flex-1 flex flex-col justify-center">
                        <div className="text-center text-gray-600 italic mt-8">
                          Deze auto is niet meer beschikbaar
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="text-center mt-12">
          <Link
            to="/Aanbod"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md text-lg font-semibold transition duration-300"
          >
            Bekijk Alle Voertuigen
          </Link>
        </div>
      </div>

      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-blue-600 text-4xl mb-4">
                <i className="fas fa-car"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Premium Selectie</h3>
              <p className="text-gray-600">Zorgvuldig samengestelde collectie kwaliteitsvoertuigen</p>
            </div>
            <div className="text-center">
              <div className="text-blue-600 text-4xl mb-4">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Gegarandeerde Kwaliteit</h3>
              <p className="text-gray-600">Alle voertuigen ondergaan een grondige inspectie</p>
            </div>
            <div className="text-center">
              <div className="text-blue-600 text-4xl mb-4">
                <i className="fas fa-handshake"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Deskundige Ondersteuning</h3>
              <p className="text-gray-600">Professionele begeleiding tijdens uw aankoop</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;    